import React, { Component } from 'react';
import { WithStyles, withStyles } from '@mui/styles';
import CircularProgress from "@mui/material/CircularProgress";
import APLoadingSpinnerStyle from "./styles/APLoadingSpinner.style";
import classnames from 'classnames';

interface APLoadingSpinnerProps
  extends WithStyles<typeof APLoadingSpinnerStyle> {
  classeName?: string;
  props?: any;
}

class APLoadingSpinner extends Component<APLoadingSpinnerProps, {}> {
  render() {
    const { classes, props, classeName } = this.props;
    return (
      <div className={classnames(classes.root, classeName)} {...props} data-testid="loader">
        <CircularProgress size={"76px"} />
      </div>
    );
  }
}

export default withStyles(APLoadingSpinnerStyle)(APLoadingSpinner);
